import zIndex from "@mui/material/styles/zIndex";
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, FormSelect } from "react-bootstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";

import texts from "./utils/langMessage";
import {
  //setting
  countryAddress2,
  provinceAddress,
  districtAddress,
  subdistrictAddress,
} from "../../redux/actions";
import { Skeleton, Divider ,Typography} from "antd";
const inputStyle = {
  width: "100%",
  height: "41px",
  borderRadius: "8px",
  position: "relative",
  //zIndex: "1050",
};

const CompanyInfoForm = ({
  companyInfoData,
  setCompanyInfoData,
  lang,
  selectProvinceOption,
  selectDistrictOption,
  selectSubDistrictOption,
  loading,
  //checkfield
  companyErrors,
  handleBlur,
  touchedFields,
}) => {
  //antd
  const { Text, Link } = Typography;

  const dispatch = useDispatch();

  console.log("CompanyInfoForm Start...");
  //selected ID
  const [selectProvince, setSelectProvince] = useState("");
  const [selectDistrict, setSelectDistrict] = useState("");
  const [selectSubDistrict, setSelectSubDistrict] = useState("");
  const [selectPostal_code, setSelectPostal_code] = useState("");

  useEffect(() => {
    if (companyInfoData?.length > 0) {
      const companyInfo = companyInfoData[0]; // Directly use the first item

      setSelectProvince(Number(companyInfo.province));
      setSelectDistrict(Number(companyInfo.district));
      setSelectSubDistrict(Number(companyInfo.subDistrict));
      setSelectPostal_code(Number(companyInfo.postalCode));
    } else {
      console.log("No company info available");
    }
  }, []);

  useEffect(() => {
    // ดึงข้อมูล Province จาก API
    dispatch(provinceAddress({ lang: "both" }));
  }, []);

  useEffect(() => {
    if (selectProvince) {
      // ดึงข้อมูล District เมื่อเลือก Province
      dispatch(districtAddress({ lang: "both", id: selectProvince }));
    }
  }, [selectProvince, lang]); // โหลดใหม่เมื่อ selectProvince หรือ lang เปลี่ยน

  useEffect(() => {
    if (selectDistrict) {
      // ดึงข้อมูล Sub District เมื่อเลือก District
      dispatch(subdistrictAddress({ id: selectDistrict, lang: "both" }));
    }
  }, [selectDistrict, lang]); // โหลดใหม่เมื่อ selectDistrict หรือ lang เปลี่ยน

  useEffect(() => {
    if (selectSubDistrict && selectSubDistrictOption.length > 0) {
      const found = selectSubDistrictOption.find(
        (item) => item.value === Number(selectSubDistrict)
      );
      // console.log("found:", found);
      if (found) {
        setSelectPostal_code(found.post_code || "N/A"); // ถ้าไม่มีค่า ให้ใช้ "N/A"
        handleInputChange("postal_code", 0, found.post_code);
      }
    }
  }, [selectSubDistrict]);

  //Handle input change
  const handleInputChange = (fieldName, index, value) => {
    setCompanyInfoData((prevData) => {
      // Create a shallow copy of the array
      const updatedData = [...prevData];
      // Update the specific field for the targeted index
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: value,
      };
      return updatedData;
    });
  };

  useEffect(() => {
    const companyInfoData0 = companyInfoData[0];

    if (companyInfoData && companyInfoData0.id_province) {
      setSelectProvince(Number(companyInfoData0.id_province));
    }

    if (companyInfoData && companyInfoData0.id_district) {
      setSelectDistrict(Number(companyInfoData0.id_district));
    }

    if (companyInfoData && companyInfoData0.id_subdistrict) {
      setSelectSubDistrict(Number(companyInfoData0.id_subdistrict));
    }

    if (companyInfoData && companyInfoData0.postal_code) {
      setSelectPostal_code(companyInfoData0.postal_code);
    }
  }, [companyInfoData]);

  function handleSelectProvince(e) {
    handleInputChange("id_province", 0, e);
    handleInputChange("id_district", 0, "");
    handleInputChange("id_subdistrict", 0, "");
    handleInputChange("postal_code", 0, "");
  }

  return (
    <Container className="">
      {companyInfoData.map((data, index) => (
        <Form

          key={index}
          className="p-4"
          style={{
            color: "rgb(0, 0, 0)",
          }}
        >
          <Divider orientation="left">
            
            Company Information
            
            </Divider>

          <Row className="mb-0">
            <Col md={6}>
              <Form.Group controlId="formCompanyName">
                <Form.Label>Company Name*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Company Name"
                  style={inputStyle}
                  name="name_company"
                  onChange={(e) =>
                    handleInputChange("name_company", index, e.target.value)
                  }
                  value={data.name_company || ""}
                  ////////
                  onBlur={() => handleBlur("name_company")}
                  isInvalid={
                    touchedFields.name_company && !!companyErrors.name_company
                  }
                  isValid={
                    touchedFields.name_company &&
                    !companyErrors.name_company &&
                    !!data.name_company
                  }
                  //////
                />

                <div
                  style={{
                    minHeight: "20px",
                    marginTop: "5px",
                    marginLeft: "10px",
                  }}
                >
                  {/* /////// */}
                  {companyErrors.name_company && touchedFields.name_company && (
                    <span className="text-danger">
                      {companyErrors.name_company}
                    </span>
                  )}
                </div>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="formCompanyName">
                <Form.Label>Company Name English*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Company Name English"
                  style={inputStyle}
                  name="name_company_en"
                  onChange={(e) =>
                    handleInputChange("name_company_en", index, e.target.value)
                  }
                  value={data.name_company_en || ""}
                  onBlur={() => handleBlur("name_company_en")}
                  isInvalid={
                    touchedFields.name_company_en &&
                    !!companyErrors.name_company_en
                  }
                  isValid={
                    touchedFields.name_company_en &&
                    !companyErrors.name_company_en &&
                    !!data.name_company_en
                  }
                />
                <div
                  style={{
                    minHeight: "20px",
                    marginTop: "5px",
                    marginLeft: "10px",
                  }}
                >
                  {companyErrors.name_company_en &&
                    touchedFields.name_company_en && (
                      <span className="text-danger">
                        {companyErrors.name_company_en}
                      </span>
                    )}
                </div>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-0">
            <Col md={6}>
              <Form.Group controlId="formBranchNumber">
                <Form.Label className="d-flex justify-items-center align-items-center mb-1">
                  Branch No.* &nbsp;&nbsp;
                  <div
                    style={{
                      display: "inline-block",
                      marginLeft: "8px",
                      marginBottom: "0px",
                      marginTop: "0px",
                    }}
                  >
                    <Form.Check
                      type="checkbox"
                      label="Head office"
                      onChange={(e) => {
                        if (e.target.checked) {
                          handleInputChange("name_branch", index, "๐๐๐๐๐");
                          handleInputChange("head_office", index, "1"); // ✅ เปลี่ยนเป็น "1"
                        } else {
                          handleInputChange("head_office", index, "0"); // ✅ เปลี่ยนเป็น "0"
                          handleInputChange("name_branch", index, "");
                        }
                      }}
                      checked={data.head_office === "1"} // ✅ ตรวจสอบว่ามีค่าเป็น "1"
                      style={{ marginBottom: "0" }} // Adjust spacing
                    />
                  </div>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter branch number"
                  style={inputStyle}
                  // value={data.name_branch}
                  name="name_branch"
                  disabled={data.head_office === "1"}
                  onChange={(e) =>
                    handleInputChange("name_branch", index, e.target.value)
                  }
                  value={data.name_branch || ""}
                  onBlur={() => handleBlur("name_branch")}
                  isInvalid={
                    touchedFields.name_branch && !!companyErrors.name_branch
                  }
                  isValid={
                    touchedFields.name_branch &&
                    !companyErrors.name_branch &&
                    !!data.name_branch
                  }
                />
                <div
                  style={{
                    minHeight: "20px",
                    marginTop: "5px",
                    marginLeft: "10px",
                  }}
                >
                  {companyErrors.name_branch && touchedFields.name_branch && (
                    <span className="text-danger">
                      {companyErrors.name_branch}
                    </span>
                  )}
                </div>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="formEmail">
                <Form.Label className="d-flex justify-items-center align-items-center mb-1">
                  Email*
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  style={inputStyle}
                  onChange={(e) =>
                    handleInputChange("email", index, e.target.value)
                  }
                  value={data.email || ""}
                  onBlur={() => handleBlur("email")}
                  isInvalid={touchedFields.email && !!companyErrors.email}
                  isValid={
                    touchedFields.email && !companyErrors.email && !!data.email
                  }
                />
                <div
                  style={{
                    minHeight: "20px",
                    marginTop: "5px",
                    marginLeft: "10px",
                  }}
                >
                  {companyErrors.email && touchedFields.email && (
                    <span className="text-danger">{companyErrors.email}</span>
                  )}
                </div>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-0">
            <Col md={6}>
              <Form.Group controlId="formPhoneNumber">
                <Form.Label>Phone No.*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter phone number"
                  style={inputStyle}
                  onChange={(e) =>
                    handleInputChange("phone_no", index, e.target.value)
                  }
                  value={data.phone_no || ""}
                  onBlur={() => handleBlur("phone_no")}
                  isInvalid={touchedFields.phone_no && !!companyErrors.phone_no}
                  isValid={
                    touchedFields.phone_no &&
                    !companyErrors.phone_no &&
                    !!data.phone_no
                  }
                />
              </Form.Group>
              <div
                style={{
                  minHeight: "20px",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              >
                {companyErrors.phone_no && touchedFields.phone_no && (
                  <span className="text-danger">{companyErrors.phone_no}</span>
                )}
              </div>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formFaxNumber">
                <Form.Label>Fax No.*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter fax number"
                  style={inputStyle}
                  onChange={(e) =>
                    handleInputChange("fax_no", index, e.target.value)
                  }
                  value={data.fax_no || ""}
                  onBlur={() => handleBlur("fax_no")}
                  isInvalid={touchedFields.fax_no && !!companyErrors.fax_no}
                  isValid={
                    touchedFields.fax_no &&
                    !companyErrors.fax_no &&
                    !!data.fax_no
                  }
                />
              </Form.Group>

              <div
                style={{
                  minHeight: "20px",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              >
                {companyErrors.fax_no && touchedFields.fax_no && (
                  <span className="text-danger">{companyErrors.fax_no}</span>
                )}
              </div>
            </Col>
          </Row>

          <Row className="mb-0">
            <Col md={12}>
              <Form.Group controlId="formTaxId">
                <Form.Label>TAX ID*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter TAX ID"
                  style={inputStyle}
                  onChange={(e) =>
                    handleInputChange("id_tax", index, e.target.value)
                  }
                  value={data.id_tax || ""}
                  onBlur={() => handleBlur("id_tax")}
                  isInvalid={touchedFields.id_tax && !!companyErrors.id_tax}
                  isValid={
                    touchedFields.id_tax &&
                    !companyErrors.id_tax &&
                    !!data.id_tax
                  }
                />
              </Form.Group>
              <div
                style={{
                  minHeight: "20px",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              >
                {companyErrors.id_tax && touchedFields.id_tax && (
                  <span className="text-danger">{companyErrors.id_tax}</span>
                )}
              </div>
            </Col>
          </Row>

          <Divider orientation="left">Address Information</Divider>

          <Row className="mb-0">
            <Col md={6}>
              <Form.Group controlId="formAddress">
                <Form.Label>Company Address*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter address"
                  style={inputStyle}
                  onChange={(e) =>
                    handleInputChange("address", index, e.target.value)
                  }
                  value={data.address || ""}
                  onBlur={() => handleBlur("address")}
                  isInvalid={touchedFields.address && !!companyErrors.address}
                  isValid={
                    touchedFields.address &&
                    !companyErrors.address &&
                    !!data.address
                  }
                />
              </Form.Group>
              <div
                style={{
                  minHeight: "20px",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              >
                {companyErrors.address && touchedFields.address && (
                  <span className="text-danger">{companyErrors.address}</span>
                )}
              </div>
            </Col>

            <Col md={6}>
              <Form.Group controlId="formAddress">
                <Form.Label>Company Address2*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter address2"
                  style={inputStyle}
                  onChange={(e) =>
                    handleInputChange("address2", index, e.target.value)
                  }
                  value={data.address2 || ""}
                  onBlur={() => handleBlur("address2")}
                  isInvalid={touchedFields.address2 && !!companyErrors.address2}
                  isValid={
                    touchedFields.address2 &&
                    !companyErrors.address2 &&
                    !!data.address2
                  }
                />
              </Form.Group>
              <div
                style={{
                  minHeight: "20px",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              >
                {companyErrors.address2 && touchedFields.address2 && (
                  <span className="text-danger">{companyErrors.address2}</span>
                )}{" "}
              </div>
            </Col>
          </Row>

          <Row className="mb-0">
            <Col md={6}>
              <Form.Group controlId="formProvince">
                <Form.Label>Province*</Form.Label>
                <Form.Select
                  placeholder="Select Province"
                  style={inputStyle}
                  onChange={(e) => {
                    // handleInputChange("id_province", index, e.target.value);
                    handleSelectProvince(e.target.value);
                    setSelectProvince(e.target.value);
                  }}
                  value={data.id_province || ""}
                  onBlur={() => handleBlur("id_province")}
                  isInvalid={
                    touchedFields.id_province && !!companyErrors.id_province
                  }
                  isValid={
                    touchedFields.id_province &&
                    !companyErrors.id_province &&
                    !!data.id_province
                  }
                >
                  <option
                    value=""
                    disabled
                    //style={{ zIndex: "1050" }}
                  >
                    Please select province {/* แสดง label ตามภาษา */}
                  </option>
                  {selectProvinceOption &&
                    selectProvinceOption.map((item, index) => (
                      <option
                        key={index}
                        value={item.value ? item.value : data.id_province || ""}
                        style={{ zIndex: "1050" }}
                      >
                        {lang === "en" ? item.label1 : item.label2}{" "}
                        {/* แสดง label ตามภาษา */}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
              <div
                style={{
                  minHeight: "20px",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              >
                {!data.id_province && companyErrors.id_province && touchedFields.id_province && (
                  <span className="text-danger">
                    {companyErrors.id_province}
                  </span>
                )}
              </div>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formDistrict">
                <Form.Label>District*</Form.Label>
                <Form.Select
                  style={inputStyle}
                  onChange={(e) => {
                    handleInputChange("id_district", index, e.target.value);
                    setSelectDistrict(e.target.value);
                  }}
                  value={data.id_district || ""}
                  onBlur={() => handleBlur("id_district")}
                  isInvalid={
                    touchedFields.id_district && !!companyErrors.id_district
                  }
                  isValid={
                    touchedFields.id_district &&
                    !companyErrors.id_district &&
                    !!data.id_district
                  }
                >
                  {/* Default option */}
                  <option value="" disabled>
                    {companyErrors.id_province
                      ? "Please select province first"
                      : "Please select district"}
                  </option>

                  {selectDistrictOption &&
                    selectDistrictOption.map((item, index) => (
                      <option
                        key={index}
                        value={item.value ? item.value : data.id_district || ""}
                      >
                        {lang === "en" ? item.label1 : item.label2}{" "}
                        {/* แสดง label ตามภาษา */}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
              <div
                style={{
                  minHeight: "20px",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              >
                {touchedFields.id_district && !data.id_district && 
                  (companyErrors.id_province || companyErrors.id_district) && (
                    <span className="text-danger mt-1 d-block">
                      {companyErrors.id_province || companyErrors.id_district}
                    </span>
                  )}
              </div>
            </Col>
          </Row>

          <Row className="mb-0">
            <Col md={6}>
              <Form.Group controlId="formSubDistrict">
                <Form.Label>Sub District*</Form.Label>
                <Form.Select
                  //disabled={!selectDistrict && !selectProvince } // ป้องกันการเลือก Sub District ก่อนเลือก District
                  style={inputStyle}
                  onChange={(e) => {
                    handleInputChange("id_subdistrict", index, e.target.value);
                    setSelectSubDistrict(e.target.value);
                  }}
                  value={data.id_subdistrict || ""}
                  onBlur={() => handleBlur("id_subdistrict")}
                  isInvalid={
                    touchedFields.id_subdistrict &&
                    !!companyErrors.id_subdistrict
                  }
                  isValid={
                    touchedFields.id_subdistrict &&
                    !companyErrors.id_subdistrict &&
                    !!data.id_subdistrict
                  }
                >
                  <option value="" disabled>
                    {companyErrors.id_province
                      ? "Please select province first"
                      : companyErrors.id_district
                      ? "Please select district"
                      : "Select district"}
                  </option>

                  {selectSubDistrictOption &&
                    selectSubDistrictOption.map((item, index) => (
                      <option
                        key={index}
                        value={
                          item.value ? item.value : data.id_subdistrict || ""
                        }
                      >
                        {lang === "en" ? item.label1 : item.label2}{" "}
                        {/* แสดง label ตามภาษา */}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
              <div
                style={{
                  minHeight: "20px",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
              >
                {touchedFields.id_subdistrict &&
                  (companyErrors.id_province ||
                    companyErrors.id_district ||
                    companyErrors.id_subdistrict) && (
                    <span className="text-danger mt-1 d-block">
                      {companyErrors.id_province ||
                        companyErrors.id_district ||
                        companyErrors.id_subdistrict}
                    </span>
                  )}
              </div>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formPostalCode">
                <Form.Label>Postal Code*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Please select sub district"
                  style={inputStyle}
                  value={
                    selectPostal_code
                      ? selectPostal_code
                      : data.postal_code || ""
                  } // แสดงค่าอัตโนมัติ
                  disabled // ป้องกันการกรอกข้อมูลด้วยมือ
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      ))}
    </Container>
  );
};
const mapStateToProps = (state) => {
  // console.log("Redux State:", state); // ตรวจสอบ state ทั้งหมด

  return {
    //Address
    selectProvinceOption: state.settings.selectProvince,
    selectDistrictOption: state.settings.selectDistrict,
    selectSubDistrictOption: state.settings.selectSubDistrict,
  };
};

const mapDispatchToProps = {
  //Address
  countryAddress2,
  provinceAddress,
  districtAddress,
  subdistrictAddress,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyInfoForm);
